document.addEventListener('DOMContentLoaded', function () {
  const kineticEls = document.querySelectorAll('[data-wknd-kinetic]');

  kineticEls.forEach((el) => {
    if (!el.dataset.wkndSplit) {
      const words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words
        .map((word, i) => `<span class="wknd-kinetic-word" style="transition-delay:${i * 0.08}s">${word}</span>`)
        .join(' ');
      el.dataset.wkndSplit = 'true';
    }
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('wknd-kinetic-in');
      } else {
        entry.target.classList.remove('wknd-kinetic-in');
      }
    });
  }, { threshold: 0.3 });

  kineticEls.forEach((el) => observer.observe(el));
});
